var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activePage === 'tasks.index')?_c('index'):_vm._e(),_vm._v(" "),(_vm.activePage === 'tasks.create')?_c('create'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }